import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, EventEmitter, Output,Input } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { AuthFormNotificationType, AuthFormType } from '@shared/models/auth.interface';
import { LoadingService, SnackbarService } from '@shared/services/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@shared/services/auth/auth.service';
const demoAnimation = trigger('demoAnimation', [
  transition(':enter', [
    style({ transform: 'translateX({{ from }})' }),
    animate('200ms', style({ transform: 'translateX(0%)' }))
  ]),
])

@Component({
  selector: 'app-forgot-userid',
  templateUrl: './forgot-userid.component.html',
  styleUrls: ['./forgot-userid.component.scss'],
  animations: [demoAnimation]
})
export class ForgotUseridComponent implements OnInit {
  
  userIDForm: FormGroup = new FormGroup({
    Email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(50)]),
   
  });
  
@Output() notify = new EventEmitter<AuthFormNotificationType | null>();
@Input() accessCode: string = '';
 @Output() formChange = new EventEmitter<AuthFormType>();
 public ErrorMessage: string = '';
  constructor(private loadingService: LoadingService,private router: Router,
    private translateService: TranslateService,private authService: AuthService,private snackbarService: SnackbarService,) {}

  toggleToForm(formType: AuthFormType): void {
    this.formChange.emit(formType);
  }

  ngOnInit(): void {
  }
  recoverUserId() {
    

    this.notify.next(null);
    const form = this.userIDForm.value;
    this.userIDForm.get('userID')?.value
    this.loadingService.showLoading();
   
 
    this.authService.recoverUserID({ EmailId:this.userIDForm.get('Email')?.value, AccessCode: this.accessCode  }).subscribe(response => {
      if (response?.Data) {
        this.formChange.emit('LOGIN');
        //this.notify.next("USERID_RECOVERY_SUCCESS");
        const responsemsg = this.translateService.instant('page.login.form.forgotUserId.recoverySuccessMessage');
        this.snackbarService.showSuccessSnackBar('Success',responsemsg, '');
        this.userIDForm.reset();
       // this.toggleToForm('LOGIN');
      } else {
        this.notify.next("UNKNOWN_ERROR");
         if (response?.Message) {
          this.ErrorMessage = response.Message;
          this.userIDForm.get('Email')?.setErrors({ serverError: this.ErrorMessage });
          this.notify.next(null);
        }
       
      }
      this.loadingService.stopLoading();
    });
  }

}
